module.exports = __webpack_public_path__ + "img/h_l.9b3698ea.png";